/* eslint-disable no-unused-vars */
import styles from './AuthLoader.module.scss'
import React from 'react'
import { ReactComponent as Logo } from '../../../assets/images/logo.svg'

function AuthLoader() {
  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo />
      </div>
      {/* <span className={styles.loading_span}>Loading</span> */}
    </div>
  )
}
export default AuthLoader
